const Shared = require("Sources/shared");
const Carousel = require("Sources/components/figurine-carousel");
const Utils = require("Sources/utils/utils");

require("Styles/pages/index.scss");

$(function()
{
  Shared.init();
  IndexPage.init();

});

var IndexPage = {};

((IndexPage) =>
{
  var carousel;
  IndexPage.init = function()
  {
    carousel = new Carousel({
      element: $(".carousel-wrapper"),
      clickCallBack: onCarouselClicked
    });

    Utils.ImageSVGToSVG();
  };

  function onCarouselClicked(e)
  {
    var el = $(e.currentTarget).find(".figurine-slide");

    window.location = "/figurines#" + el.data("figurine-id");
  }
})(IndexPage);



// WEBPACK FOOTER //
// ./app/js/entries/index.js